import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { UserProvider, useUser } from './UserContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import SignUpPage from './pages/SignUpPage';
import AddToolPage from './pages/AddToolPage';
import EditToolPage from './pages/EditToolPage';
import ToolDetailPage from './pages/ToolDetailPage';
import MyToolsPage from './pages/MyToolsPage';
import AdminPage from './pages/AdminPage';
import ProfilePage from './pages/ProfilePage';
import RequestsPage from './pages/RequestsPage';
import OnboardingPage from './pages/OnboardingPage';
import WellTestingPage from './pages/WellTestingPage';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!user.onboardingCompleted && window.location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" />;
  }

  return children;
};

const SignUpWrapper = () => {
  const { user } = useUser();
  
  if (user && !user.onboardingCompleted) {
    return <Navigate to="/onboarding" />;
  }
  
  return <SignUpPage />;
};

function AppContent() {
  const { loading } = useUser();

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <div className="mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/signup" element={<SignUpWrapper />} />
            <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
            <Route path="/add-tool" element={<ProtectedRoute><AddToolPage /></ProtectedRoute>} />
            <Route path="/edit-tool/:toolId" element={<ProtectedRoute><EditToolPage /></ProtectedRoute>} />
            <Route path="/tool/:id" element={<ProtectedRoute><ToolDetailPage /></ProtectedRoute>} />
            <Route path="/my-tools" element={<ProtectedRoute><MyToolsPage /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
            <Route path="/requests" element={<ProtectedRoute><RequestsPage /></ProtectedRoute>} />
            <Route path="/well-testing" element={<WellTestingPage />} />
          </Routes>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </HelmetProvider>
  );
}

export default App;
